import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { CustomChart1Component } from './custom-chart1/custom-chart1.component';
import { FlexLayoutModule } from '@angular/flex-layout';
import { ChangelogDialogComponent } from './changelog-dialog/changelog-dialog.component';
import {MaterialModule} from '../modules/material/material.module';
import {TranslateModule} from '@ngx-translate/core';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {FormsModule} from '@angular/forms';



@NgModule({
  declarations: [CustomChart1Component, ChangelogDialogComponent],
  imports: [
    CommonModule,
    NgxChartsModule,
    MatIconModule,
    MatButtonModule,
    FlexLayoutModule,
    MaterialModule,
    TranslateModule,
    MatProgressSpinnerModule,
    FormsModule
  ],
  exports: [],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class ComponentsModule { }
